import type { Currency } from '../hooks/useCurrency';
import { CURRENCIES } from '../hooks/useCurrency';

/**
 * CurrencyToggle Component (Phase 1.2)
 *
 * A compact toggle button group for switching between currencies (GBP/EUR/USD).
 */

interface CurrencyToggleProps {
  current: Currency;
  onChange: (currency: Currency) => void;
}

export function CurrencyToggle({ current, onChange }: CurrencyToggleProps) {
  return (
    <div
      role="group"
      aria-label="Currency selection"
      className="inline-flex rounded-lg bg-neutral-900 border border-neutral-800 p-0.5"
    >
      {CURRENCIES.map((currency) => {
        const isActive = currency === current;
        return (
          <button
            key={currency}
            type="button"
            onClick={() => {
              if (!isActive) {
                onChange(currency);
              }
            }}
            aria-pressed={isActive}
            className={`
              px-2.5 py-1 text-xs font-mono font-medium rounded-md transition-colors
              ${
                isActive
                  ? 'bg-orange-500 text-white'
                  : 'text-neutral-400 hover:text-white hover:bg-neutral-800'
              }
            `}
          >
            {currency}
          </button>
        );
      })}
    </div>
  );
}
